import React, { useState } from "react";
import { LockOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import BgWrapper from "../../components/layout/BgWrapper";
import ROUTES from "../../routes";
import { resetReqInfo, resetSuccessInfo } from "./constants";
import { ResetRequest, ResetSuccess } from "../../components/_shared/ResetView";
import PasswordConfirmForm from "../../components/_shared/PasswordConfirmForm";

function ResetPass() {
  const navigate = useNavigate();
  const [resetReq, setResestReq] = useState(false);

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const onFinish = (values: any) => {
    // console.log("Received values of form: ", values);
    setResestReq(true);
  };

  const onLogin = () => navigate(ROUTES.PATHS.LOGIN);

  return (
    <BgWrapper>
      <>
        {resetReq && <ResetSuccess info={resetSuccessInfo} onClick={onLogin} />}
        {resetReq || (
          <ResetRequest info={resetReqInfo} onFinish={onFinish}>
            <PasswordConfirmForm
              prefix={<LockOutlined className="text-primary pr-1" />}
              placeholder
              tip="Strong password contains at least 8 characters with upper and lower case and one number or symbol"
              required
            />
          </ResetRequest>
        )}
      </>
    </BgWrapper>
  );
}

export default ResetPass;
